import CarouselZoom from "../../components/carouselZoom/CarouselZoom";
import "./home.css";
import About from "./seccions/about/About";
import Services from "./seccions/services/Services";
import WsFloating from "../../components/wsFloating/WsFloating";
import NavBar from "../../components/navBar/NavBar";
import Contact from "./seccions/contact/Contact";

const Home = () => {
    return (
        <div className="seccionToWaitImages homeCont" id="home">
            <NavBar/>
            <CarouselZoom/>
            <div className="carouselSeccionRightCont flex">
                <div className="carouselSeccionRightInfoCont flex column">
                    <div className="carouselSeccionRightInfoElementCont flex">
                        <img src="/images/icons/location.png" alt="Location" className="carouselSeccionRightInfoImg"/>
                        <p className="carouselSeccionRightInfoText">Buenos Aires, Argentina.</p>
                    </div>
                    <div className="carouselSeccionRightInfoElementCont flex">
                        <img src="/images/icons/tel.png" alt="Location" className="carouselSeccionRightInfoImg"/>
                        <p className="carouselSeccionRightInfoText carouselSeccionRightInfoTextTel">11-3885-1259 <br /> 11-3295-4080</p>
                    </div>
                    <div className="carouselSeccionRightInfoElementCont flex">
                        <img src="/images/icons/email.png" alt="Location" className="carouselSeccionRightInfoImg"/>
                        <a className="carouselSeccionRightInfoText" href="mailto:info@iterpros.com.ar">info@iterpros.com.ar</a>
                    </div>
                </div>
                <img src="/images/formas/2.png" alt="Forma" className="carouselSeccionRightForm1"/>
                <img src="/images/formas/2.png" alt="Forma" className="carouselSeccionRightForm2"/>
            </div>

            <About/>
            <Services/>
            <WsFloating/>
            <Contact/>
        </div>
    );
};

export default Home;
